module.exports = {
    videoElement: null,

    /**
     *
     * @param image
     * @param video
     *
     * Если существуют то после воспроизведения видео будет переход на них
     * @param url - Ссылка
     * @param slideId - Переход на слайд
     */
    set: (image, video, url, slideId) => {
        if (video) {
            module.exports.setBgVideo(video, image, url, slideId);
        } else {
            module.exports.setBgImage(image);
        }
    },

    setBgImage: (imagePath) => {
        const layerBG = window.STAGE.find('.bg-layer')[0];

        // Удаление текущего фона
        module.exports.removeBgImage();

        // const imageObj = new Image();
        const imageObj = window.cacheImages.find(e => e.src === imagePath).el;
        // imageObj.onload = () => {
        let newWidth, newHeight, x, y;
        const aspectRatio = window.MAIN_WIDTH / window.MAIN_HEIGHT;

        const imageRatio = imageObj.width / imageObj.height;


        if (aspectRatio >= imageRatio) {
            newWidth = imageObj.width;
            newHeight = imageObj.width / aspectRatio;
        } else {
            newWidth = imageObj.height * aspectRatio;
            newHeight = imageObj.height;
        }

        x = (imageObj.width - newWidth) / 2;
        y = (imageObj.height - newHeight) / 2;

        const background = new Konva.Image({
            x: 0,
            y: 0,
            width: window.MAIN_WIDTH,
            height: window.MAIN_HEIGHT,
            image: imageObj,
            name: 'bg',
            cropX: x,
            cropY: y,
            cropWidth: newWidth,
            cropHeight: newHeight,
        });

        layerBG.add(background);
        background.moveToBottom();
        //==STAGE.getLayers()[1].add(background);
        //  };
        // imageObj.src = '/' + imagePath;
    },

    setBgVideo: (videoPath, imagePath, url, slideId) => {
        const layerBG = window.STAGE.find('.bg-layer')[0];
        let newWidth, newHeight, x, y;

        // Очистка слоя
        module.exports.clearLayer();

        // Создание блока с информацией по загрузки видео
        const bottomTextGroup = new Konva.Group({
            name: 'bottom-info'
        })
        const bottomRect = new Konva.Rect({
            x: MAIN_WIDTH - 150,
            y: MAIN_HEIGHT - 20,
            width: 150,
            height: 20,
            fill: '#5c5c5c',
            opacity: 0.6,
            cornerRadius: [10, 0, 0, 0],
        })

        const bottomText = new Konva.Text({
            x: MAIN_WIDTH - 150,
            y: MAIN_HEIGHT - 20,
            width: 150,
            height: 20,
            fontSize: 11,
            fill: '#fff',
            text: 'Загрузка видео...',
            opacity: 0.6,
            name: 'video-alert',
            align: 'center',
            verticalAlign: 'middle'
        })
        bottomTextGroup.add(bottomRect);
        //text.zIndex(5);
        bottomTextGroup.add(bottomText);
        layerBG.add(bottomTextGroup)

        // Создание HTML видео
        var videoElement = document.createElement('video');
        module.exports.videoElement = videoElement;
        videoElement.setAttribute('playsinline', 'true');
        videoElement.setAttribute('src', '/' + videoPath);
        videoElement.autoplay = true;


        // Добавление видео в Konva для позицирования
        const background = new Konva.Image({
            x: 0,
            y: 0,
            width: window.MAIN_WIDTH,
            height: window.MAIN_HEIGHT,
            image: videoElement,
            name: 'bg-video',

        });
        layerBG.add(background);
        background.moveToBottom();

        // Установка постера
        if (imagePath) {
            module.exports.setBgImage(imagePath);
        }

        window.UpdateLayer.start();

        videoElement.addEventListener('error', function (e) {
            console.log('Error', e);
            bottomText.text('Ошибка загрузки');
            bottomRect.fill('#ff0000');
        })

        // Событие определяет что браузер загрузил данные видео и готов воспроизвести его
        videoElement.addEventListener('loadedmetadata', function (e) {
            // Определение размера видео в соотношении сторон слайда
            const aspectRatio = MAIN_WIDTH / MAIN_HEIGHT;

            const imageRatio = videoElement.videoWidth / videoElement.videoHeight;

            if (aspectRatio >= imageRatio) {
                newWidth = videoElement.videoWidth;
                newHeight = videoElement.videoWidth / aspectRatio;
            } else {
                newWidth = videoElement.videoHeight * aspectRatio;
                newHeight = videoElement.videoHeight;
            }

            x = (videoElement.videoWidth - newWidth) / 2;
            y = (videoElement.videoHeight - newHeight) / 2;

            // Установка размеров в Konva
            background.cropX(x);
            background.cropY(y);
            background.cropWidth(newWidth);
            background.cropHeight(newHeight);

            bottomTextGroup.remove();
            window.UpdateLayer.start(); // Обновление слоя для отображения видео

            videoElement.muted = true;

            // Если есть ссылка или слайд, то после окончания воспроизведения выполнить переход
            if (slideId) {
                videoElement.addEventListener('ended', () => {
                    if (slideId) {
                        KonvaController.openSlide(slideId)
                    }
                })
            } else {
                // Запуск видео в фоне
                videoElement.loop = true;
            }
            videoElement.play();

            module.exports.createBtnSwitchMute(layerBG, videoElement)
        });
    },

    /**
     * Включение/Отключение звука видео
     * @param layerBG
     * @param video
     */
    createBtnSwitchMute: (layerBG, video) => {
        const button = new Konva.Text({
            x: MAIN_WIDTH - 50,
            y: MAIN_HEIGHT - 50,
            width: 50,
            height: 50,
            fontSize: 20,
            fill: '#fff',
            fontFamily: 'icomoon',
            text: '',
            opacity: 0.6,
            name: 'video-alert',
            align: 'center',
            verticalAlign: 'middle'
        });
        button.on('click touchstart', () => {
            video.muted = !video.muted;
            if (video.muted) {
                button.text('')
            } else {
                button.text('')
            }
        });

        button.on('mouseenter', function () {
            STAGE.container().style.cursor = 'pointer';
        });
        button.on('mouseleave', function () {
            STAGE.container().style.cursor = 'default';
        });

        layerBG.add(button);
    },

    clearLayer: () => {
        const layerBG = window.STAGE.find('.bg-layer')[0];
        // Очистка видео
        if (module.exports.videoElement) {
            module.exports.videoElement.pause();
            module.exports.videoElement.removeAttribute('src');
            module.exports.videoElement.remove();
            module.exports.videoElement = undefined;
        }
        layerBG.destroyChildren();
    },

    removeBgImage: () => {
        const layerBG = window.STAGE.find('.bg-layer')[0];
        const currentBG = layerBG.findOne('.bg');
        if (currentBG) {
            currentBG.remove();
        }
    }


}
